import React from "react";

export const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="bg-primary-600 text-white mt-auto">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 py-8">
        <div className="text-center">
          <p className="text-sm text-white">
            © {currentYear} Menas B2B Order. All rights reserved.
          </p>
          <p className="text-xs text-white mt-2">
            Bản quyền thuộc về Menas B2B Order
          </p>
        </div>
      </div>
    </footer>
  );
};

